module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "实时数据",
      "description": "提供网站实时的流量数据，通过流量的趋势变化，来分析出网站访客的访问规律、网站发展状况等",
      "pos": "right"
    }
  }), _c('TopStatis', {
    attrs: {
      "data": _vm.topStatisData
    }
  }), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }, [_c('div', {
    staticClass: "realtime-uv"
  }, [_vm._v("当前在线人数 " + _vm._s(_vm.realTimeUV))])]), _c('div', {
    staticClass: "header-chart-line"
  }), _c('div', {
    staticClass: "toggle-flow-type"
  }, [_c('span', {
    staticClass: "checkbox",
    class: {
      checked: _vm.flowChartType === 'pv'
    },
    on: {
      "click": function($event) {
        _vm.changeFlowType('pv')
      }
    }
  }, [_vm._v("浏览量(PV)")]), _c('span', {
    staticClass: "checkbox",
    class: {
      checked: _vm.flowChartType === 'uv'
    },
    on: {
      "click": function($event) {
        _vm.changeFlowType('uv')
      }
    }
  }, [_vm._v("访客数(UV)")])]), _c('LineChart', {
    attrs: {
      "legend": _vm.flowChartLegend,
      "xAxis": _vm.flowChartXAxis,
      "series": _vm.flowChartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": "实时访客报表"
    }
  }, [_c('small', {
    staticClass: "table-title-tip"
  }, [_vm._v("（实时数据用于实时查看网站访问明细，不作为推广点击扣费及反作弊数据源，360推广消费数据请以点睛后台数据为准）")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visitorList.length),
      expression: "visitorList.length"
    }],
    staticClass: "download-btn"
  }, [_c('DownloadBtn', {
    attrs: {
      "reportApi": "/api/realtime/top",
      "pagetitle": "实时访客报表",
      "params": _vm.downloadParams
    }
  })], 1)]), _c('div', {
    staticClass: "header-chart-line"
  }), _c('div', {
    staticClass: "table-tool-row"
  }, [_vm._v("访问来源："), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterParams.refertype),
      expression: "filterParams.refertype"
    }],
    attrs: {
      "options": _vm.refertypeOptions
    },
    domProps: {
      "value": (_vm.filterParams.refertype)
    },
    on: {
      "input": [function($event) {
        _vm.filterParams.refertype = $event
      }, _vm.getVisitorList]
    }
  }), _vm._v("访问设备："), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterParams.device),
      expression: "filterParams.device"
    }],
    attrs: {
      "options": _vm.deviceOptions
    },
    domProps: {
      "value": (_vm.filterParams.device)
    },
    on: {
      "input": [function($event) {
        _vm.filterParams.device = $event
      }, _vm.getVisitorList]
    }
  }), _vm._v("访问地域："), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterParams.region),
      expression: "filterParams.region"
    }],
    attrs: {
      "options": _vm.regionOptions
    },
    domProps: {
      "value": (_vm.filterParams.region)
    },
    on: {
      "input": [function($event) {
        _vm.filterParams.region = $event
      }, _vm.getVisitorList]
    }
  }), _c('div', {
    staticClass: "realtime-search pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterParams.keyword),
      expression: "filterParams.keyword"
    }],
    attrs: {
      "placeholder": "搜索词"
    },
    domProps: {
      "value": _vm._s(_vm.filterParams.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterParams.keyword = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": _vm.getVisitorList
    }
  }, [_vm._v("搜索")])])], 1), _c('table', {
    staticClass: "data-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "50"
    }
  }, [_vm._v("序号")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("访客ID")]), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("访客IP")]), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("访问时间"), _c('span', {
    staticClass: "sort_icon margin_icon"
  }, [_c('i', {
    staticClass: "sort sort-asc",
    class: {
      sorted: _vm.listOrder === 'asc'
    },
    on: {
      "click": function($event) {
        _vm.visitorListSort('asc')
      }
    }
  }), _c('i', {
    staticClass: "sort sort-desc",
    class: {
      sorted: _vm.listOrder === 'desc'
    },
    on: {
      "click": function($event) {
        _vm.visitorListSort('desc')
      }
    }
  })])]), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("地域")]), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("搜索词")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("来源")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("入口页面")])])]), _c('tbody', [_vm._l((_vm.currentPageList), function(visitor, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isListLoading && _vm.visitorList.length),
        expression: "!isListLoading && visitorList.length"
      }]
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(visitor.guid))]), _c('td', [_vm._v(_vm._s(visitor.ip))]), _c('td', [_vm._v(_vm._s(visitor.vtime))]), _c('td', [_vm._v(_vm._s(visitor.province))]), _c('td', [_vm._v(_vm._s(visitor.keyword || '--'))]), _c('td', [_c('span', {
      attrs: {
        "title": visitor.refer
      }
    }, [_vm._v(_vm._s(visitor.refer))])]), _c('td', [_c('a', {
      attrs: {
        "href": _vm._f("httpUrl")(visitor.eurl),
        "title": _vm._f("httpUrl")(visitor.eurl),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(visitor.eurl))])])])
  }), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isListLoading && _vm.visitorList.length === 0),
      expression: "!isListLoading && visitorList.length === 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("暂无数据")])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListLoading && _vm.visitorList.length === 0),
      expression: "isListLoading && visitorList.length === 0"
    }]
  }, [_vm._m(0)])], 2)]), _c('v-pagination', {
    attrs: {
      "total": _vm.visitorList.length,
      "pn": _vm.pageNum,
      "ps": "10"
    },
    on: {
      "updatepage": _vm.onPageChange
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('img', {
    attrs: {
      "src": "//p.ssl.qhimg.com/t010aba4345b02168d6.gif"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17c48276", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17c48276!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/realtime.vue
// module id = 719
// module chunks = 0